import React from 'react';

import { TextInput } from '@sravni/react-design-system';

import { FILTERS_NAMES } from '../../../constants/news';

import { ITagsProps } from './Tags';

interface IProps extends Pick<ITagsProps, 'handleFiltersChange' | 'filters'> {}

export const Search = ({ handleFiltersChange, filters }: IProps) => {
  const handleSearchChange = (e) => {
    handleFiltersChange(FILTERS_NAMES.TEXT, e.target.value);
  };

  return (
    <TextInput value={filters[FILTERS_NAMES.TEXT]} onChange={handleSearchChange} placeholder={'Поиск по проектам'} />
  );
};
